import { render, staticRenderFns } from "./UrbanRenewalAdminLayout.vue?vue&type=template&id=0241b04b"
import script from "./UrbanRenewalAdminLayout.vue?vue&type=script&lang=js"
export * from "./UrbanRenewalAdminLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports